module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-14.fd1a95e8.png";